module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-form-5ef7700c09e1621b1a00c69d7ff0f2f8.svg";